import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcess(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/uniq_final_packing_list/query/fetch_agro_exporter_process/${agro_exporter_process_id}`
    );
  }
};
